import { Injectable } from '@angular/core';
import { Tools } from '../tools/tools';
import { Api } from '../api/api';


@Injectable()
export class User {
  _user: any;
  _login: any;

  constructor(
    private api: Api,
    private tools: Tools
  ) {}

  tratCallback(res:any,callback:any){
    if(res.status){
      callback({status:true,data:res})
    }else{
      callback({status:false,msg:res.error,data:res})
    }
  }

  login(accountInfo:any,remember:boolean,callback:any){
    this.serviceLogin(accountInfo,(result)=>{
      if(result.status){
        this._loggedIn(result.data);
        if(remember){
          this.tools.storage('set','login',accountInfo,(res)=>callback({status:result.status,msg:'Acesso Autorizado'}));
        }else{
          this.tools.storage('del','login',null,(res)=>callback({status:result.status,msg:'Acesso Autorizado'}));
        }
      }else{
        callback(result);
      }
    });
  }

  signup(accountInfo: any,callback:any) {
    this.serviceSignup(accountInfo,(result)=>{
      if(result.status){
        // this._loggedIn(result.user);
        callback({status:result.status,msg:'Assinatura confirmada'});
      }else{
        callback(result);
      }
    });
  }

  serviceLogin(accountInfo: any,callback:any) {
    this.api.setHost(accountInfo.host);
    // console.log(accountInfo)
    this.api.request('post','auth',accountInfo,{},(res)=>this.tratCallback(res,callback))
  }

  serviceSignup(accountInfo: any,callback:any) {
    this.api.setHost(accountInfo.host);
    // console.log(accountInfo)
    this.api.request('post','signup',accountInfo,{},(res)=>this.tratCallback(res,callback))
  }

  logout() {
    this._user = null;
  }

  getUser(){
    return this._user;
  }

  getSession(){
    return this._user.session;
  }

  getHost(){
    return this.api.getHost();
  }

  _loggedIn(resp) {
    this._user = resp.user;
  }

  insertUser(item:any){
    this._user = item;
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts